import { render, staticRenderFns } from "./KwKarten.vue?vue&type=template&id=0377c6d0&scoped=true&"
import script from "./KwKarten.vue?vue&type=script&lang=js&"
export * from "./KwKarten.vue?vue&type=script&lang=js&"
import style0 from "./KwKarten.vue?vue&type=style&index=0&id=0377c6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0377c6d0",
  null
  
)

export default component.exports